import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RequestStatus } from 'features/common'
import { RequestAccessForm } from 'features/data-observatory/types'
import { QuotasRequestOptions, RequestSubscriptionHubspotFormProps } from '../types'

export const name = 'hubspot'

export interface HubspotState {
  subscriptionRequestStatus: RequestStatus
  planLimitStatus: RequestStatus
  accountLimitStatus: RequestStatus
  requestAccessStatus: RequestStatus
  contactMeStatus: RequestStatus
}

const initialState: HubspotState = {
  subscriptionRequestStatus: RequestStatus.Idle,
  planLimitStatus: RequestStatus.Idle,
  accountLimitStatus: RequestStatus.Idle,
  requestAccessStatus: RequestStatus.Idle,
  contactMeStatus: RequestStatus.Idle
}

const asyncActions = {
  requestContactMeRequest: createAction<{ feature }>(`${name}/request_contact_me_request`),
  requestAccessRequest: createAction<RequestAccessForm>(`${name}/request_access_request`),
  requestSubscription: createAction<RequestSubscriptionHubspotFormProps>(`${name}/request_subscription`),
  cancelRequestSubscription: createAction<RequestSubscriptionHubspotFormProps>(`${name}/cancel_request_subscription`),
  planLimitRequest: createAction(`${name}/plan_limit_request`),
  accountLimitRequest: createAction<QuotasRequestOptions>(`${name}/account_limit_request`)
}

const reducers = {
  setRequestContactMeStatus: (state: HubspotState, action: PayloadAction<RequestStatus>) => {
    state.contactMeStatus = action.payload
  },
  setRequestAccessStatus: (state: HubspotState, action: PayloadAction<RequestStatus>) => {
    state.requestAccessStatus = action.payload
  },
  setRequestSubscriptionStatus: (state: HubspotState, action: PayloadAction<RequestStatus>) => {
    state.subscriptionRequestStatus = action.payload
  },
  setPlanLimitStatus: (state: HubspotState, action: PayloadAction<RequestStatus>) => {
    state.planLimitStatus = action.payload
  },
  setAccountLimitStatus: (state: HubspotState, action: PayloadAction<RequestStatus>) => {
    state.accountLimitStatus = action.payload
  }
}

export const hubspotSlice = createSlice({
  name,
  initialState,
  reducers
})

export const {
  setPlanLimitStatus,
  setAccountLimitStatus,
  setRequestSubscriptionStatus,
  setRequestAccessStatus,
  setRequestContactMeStatus
} = hubspotSlice.actions

export const {
  planLimitRequest,
  accountLimitRequest,
  requestSubscription,
  cancelRequestSubscription,
  requestAccessRequest,
  requestContactMeRequest
} = asyncActions

export default hubspotSlice.reducer
